import { render, staticRenderFns } from "./Distribution.vue?vue&type=template&id=a49b790e&"
import script from "./Distribution.vue?vue&type=script&lang=ts&"
export * from "./Distribution.vue?vue&type=script&lang=ts&"
import style0 from "./Distribution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports